import React, { useState, useEffect } from 'react';
import { API } from '../contexts/AuthContext';
import axios from 'axios';
import Swal from 'sweetalert2';

export default function Perfis() {
  const [perfis, setPerfis] = useState([]);
  const [permissoes, setPermissoes] = useState([]);
  const [editando, setEditando] = useState(null);
  const [nome, setNome] = useState('');
  const [descricao, setDescricao] = useState('');
  const [selecionadas, setSelecionadas] = useState([]);

  const carregar = () => {
    Promise.all([
      axios.get(`${API}/perfis`),
      axios.get(`${API}/perfis/permissoes`)
    ]).then(([p, perm]) => {
      setPerfis(p.data);
      setPermissoes(perm.data);
    }).catch(() => {});
  };

  useEffect(carregar, []);

  const grupos = [...new Set(permissoes.map(p => p.grupo))];

  const iniciarEdicao = (perfil) => {
    setEditando(perfil.id);
    setNome(perfil.nome);
    setDescricao(perfil.descricao || '');
    setSelecionadas(perfil.permissoes.map(p => p.permissao_id));
  };

  const cancelar = () => { setEditando(null); setNome(''); setDescricao(''); setSelecionadas([]); };

  const salvar = async () => {
    if (!nome) return Swal.fire('Atenção', 'Nome obrigatório', 'warning');
    try {
      if (editando) {
        await axios.put(`${API}/perfis/${editando}`, { nome, descricao, permissoes: selecionadas });
      } else {
        await axios.post(`${API}/perfis`, { nome, descricao, permissoes: selecionadas });
      }
      Swal.fire({ icon: 'success', title: 'Salvo!', timer: 1500, showConfirmButton: false });
      cancelar();
      carregar();
    } catch (err) {
      Swal.fire('Erro', err.response?.data?.error || 'Erro ao salvar', 'error');
    }
  };

  const togglePerm = (id) => {
    setSelecionadas(prev => prev.includes(id) ? prev.filter(p => p !== id) : [...prev, id]);
  };

  return (
    <div>
      <h4 className="fw-bold mb-4">Perfis e Permissões</h4>

      <div className="card p-3 mb-4">
        <h6 className="fw-bold mb-3">{editando ? 'Editar Perfil' : 'Novo Perfil'}</h6>
        <div className="row g-2 mb-3">
          <div className="col-md-4">
            <input className="form-control" placeholder="Nome do perfil" value={nome} onChange={e => setNome(e.target.value)} />
          </div>
          <div className="col-md-6">
            <input className="form-control" placeholder="Descrição (opcional)" value={descricao} onChange={e => setDescricao(e.target.value)} />
          </div>
        </div>

        <p className="text-muted mb-3" style={{ fontSize: '0.82rem' }}>
          <i className="bi bi-info-circle me-1"></i>
          Marque o que este perfil pode fazer. Cada item explica abaixo o que libera.
        </p>
        {grupos.map(g => (
          <div key={g} className="mb-3">
            <div className="fw-bold mb-2" style={{ fontSize: '0.92rem', color: 'var(--mostarda)', borderBottom: '1px solid #eee', paddingBottom: 4 }}>{g}</div>
            <div className="d-flex flex-column gap-2">
              {permissoes.filter(p => p.grupo === g).map(p => {
                const marcada = selecionadas.includes(p.id);
                return (
                  <label key={p.id} className="d-flex align-items-start gap-2" style={{ cursor: 'pointer', background: marcada ? '#f5ebf2' : 'transparent', borderRadius: 6, padding: '6px 8px' }}>
                    <input type="checkbox" className="mt-1" checked={marcada} onChange={() => togglePerm(p.id)} />
                    <span>
                      <span className="fw-semibold" style={{ fontSize: '0.88rem' }}>{p.nome}</span>
                      {p.descricao && <span className="d-block text-muted" style={{ fontSize: '0.78rem', lineHeight: 1.35 }}>{p.descricao}</span>}
                    </span>
                  </label>
                );
              })}
            </div>
          </div>
        ))}

        <div className="d-flex gap-2 mt-3">
          <button className="btn-primary-mkt" onClick={salvar}>{editando ? 'Atualizar' : 'Criar'}</button>
          {editando && <button className="btn-outline-mkt" onClick={cancelar}>Cancelar</button>}
        </div>
      </div>

      <div className="card p-3">
        <h6 className="fw-bold mb-3">Perfis Cadastrados</h6>
        {perfis.map(p => (
          <div key={p.id} className="d-flex align-items-center justify-content-between py-2 border-bottom">
            <div>
              <strong>{p.nome}</strong>
              <div style={{ fontSize: '0.78rem', color: '#888' }}>
                {p.permissoes.map(perm => perm.nome).join(', ') || 'Sem permissões'}
              </div>
            </div>
            <button className="btn-outline-mkt btn-sm" onClick={() => iniciarEdicao(p)}>
              <i className="bi bi-pencil"></i>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
